/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_createDocumentResponse } from '../models/api_createDocumentResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Documents {
    /**
     * Get a document
     * @param id Beneficiary ID
     * @param documentId Document ID
     * @returns binary OK
     * @throws ApiError
     */
    public static getDocument(
        id: number,
        documentId: number,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/documents/{document_id}',
            path: {
                'id': id,
                'document_id': documentId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                502: `Bad Gateway`,
            },
        });
    }
    /**
     * Upload a file, create a document record
     * @param documentFile Document file
     * @returns api_createDocumentResponse OK
     * @throws ApiError
     */
    public static createDocument(
        documentFile?: Blob,
    ): CancelablePromise<api_createDocumentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/documents',
            formData: {
                'document_file': documentFile,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a user document
     * @param id Document ID
     * @returns binary OK
     * @throws ApiError
     */
    public static getUserDocument(
        id: number,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/documents/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                502: `Bad Gateway`,
            },
        });
    }
}
